export const habaContactForm = {
  habaContactForm: {
    success: {
      title: 'Thank you for your message',
      txt: 'We will process your request as soon as possible'
    },
    messages: {
      notValidError: 'Invalid entries',
      serverError: 'An unknown error has occurred'
    },
    form: {
      legend: 'Contact form',
      reason: {
        label: 'Reason for your request',
        error: 'Please select a reason for your request'
      },
      reference: {
        label: 'Subject',
        error: 'Please enter a subject'
      },
      file: {
        label: 'Upload file (optional)',
        button: 'Upload file...',
        error: 'Please choose a file',
        additionalInformation: 'Allowed files: .pdf, .jpg, .jpeg, .png (total size max 15 MB)'
      },
      message: {
        label: 'Your message',
        error: 'Please enter your message'
      },
      customerType: {
        firm: 'Firm',
        institution: 'Institution',
        private: 'Private person'
      },
      name: {
        label: 'Name',
        error: 'Please enter your name'
      },
      firstName: {
        label: 'Firstname',
        error: 'Please enter your firstname'
      },
      lastName: {
        label: 'Nachname',
        error: 'Please enter your lastName'
      },
      customerNumber: {
        label: 'Customer number (optional)',
        error: 'Please enter a valid customer number'
      },
      orderNumber: {
        label: 'Order number (optional)',
        error: 'Please enter a valid order number'
      },
      street: {
        label: 'Street',
        error: 'Please enter your Street'
      },
      houseNumber: {
        label: 'House number',
        error: 'Please enter your house number'
      },
      postcode: {
        label: 'Postal code',
        error: 'Please enter your postal code'
      },
      location: {
        label: 'Location',
        error: 'Please enter your location'
      },
      country: {
        label: 'Country',
        error: 'Please enter your country'
      },
      email: {
        label: 'E-mail address',
        error: 'Please enter your e-mail address'
      },
      phone: {
        label: 'Phone number (optional)',
        error: 'Please enter a valid phone number',
        formatError:
          'Please enter a valid phone number (7–20 characters; only digits and + - / , ( ) are allowed).'
      },
      isAgreed: {
        label:
          'I agree that my personal information and my message will be processed exclusively for the purpose of processing and processing my request. This data is processed on the basis of Art. 6 Para. 1 lit. a or Art. 6 Para. 1 lit. b GDPR (see <strong>Privacy Policy</strong>)',
        error: 'Please confirm'
      },
      submit: 'Send'
    },
    formProductAdvisor: {
      description: 'Fill out the form and an advisor will contact you.',
      contactUs: 'Contact us',
      option: {
        description: 'Choose your preferred contact method',
        message: 'Write a message',
        call: 'Call',
        mail: 'Send e-mail',
      },
    },
    whenStuck: 'Wenn sie nicht weiterkommen, dann nutzen Sie bitte das ',
    formular: 'Formular',
    whenStuckEnglish: 'If you get stuck, please use the ',
    formularEnglish: 'form'
  }
};
